import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function IncludedSection() {
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-cream" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-warm-900" data-id="element-76">
          Dentro de este libro vas a descubrir...
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-77">
          {['Más de 100 recetas fáciles para Air Fryer', 'Platos listos en menos de 15 minutos', 'Comidas simples con ingredientes que podés conseguir en cualquier supermercado', 'Tiempos y temperaturas exactas para que siempre queden perfectas', 'Opciones saludables sin aceite', 'Comidas que toda la familia va a disfrutar'].map((item, index) => <div key={index} className="bg-white rounded-2xl p-6 flex items-start gap-4 border border-warm-400 shadow-sm" data-id="element-78">
              <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-79" />
              <span className="text-lg text-warm-800" data-id="element-80">{item}</span>
            </div>)}
        </div>

        <div className="bg-secondary/10 border border-secondary/30 rounded-2xl p-8 mb-12 text-center" data-id="element-81">
          <p className="text-xl text-warm-900 italic" data-id="element-82">
            "Imaginá poder cocinar papas crujientes perfectas, pollo dorado y
            jugoso, vegetales deliciosos, snacks saludables y postres rápidos,
            todo usando solo tu Air Fryer y en cuestión de minutos."
          </p>
        </div>

        <div className="space-y-12 mb-16" data-id="element-83">
          <div data-id="element-84">
            <h3 className="text-2xl font-bold text-primary mb-6" data-id="element-85">
              Este libro es perfecto si...
            </h3>
            <ul className="space-y-4 text-warm-800 text-lg" data-id="element-86">
              <li className="flex items-center gap-3" data-id="element-87">
                <span className="text-primary" data-id="element-88">•</span> Tenés una Air Fryer pero
                no sabés qué cocinar
              </li>
              <li className="flex items-center gap-3" data-id="element-89">
                <span className="text-primary" data-id="element-90">•</span> Querés comer más
                saludable evitando frituras
              </li>
              <li className="flex items-center gap-3" data-id="element-91">
                <span className="text-primary" data-id="element-92">•</span> No tenés mucho tiempo
                para cocinar
              </li>
              <li className="flex items-center gap-3" data-id="element-93">
                <span className="text-primary" data-id="element-94">•</span> Te gusta preparar
                comidas ricas para tu familia
              </li>
              <li className="flex items-center gap-3" data-id="element-95">
                <span className="text-primary" data-id="element-96">•</span> Simplemente querés
                aprovechar al máximo tu Air Fryer
              </li>
            </ul>
          </div>

          <div data-id="element-97">
            <h3 className="text-2xl font-bold text-primary mb-6" data-id="element-98">
              Con esta guía vas a poder...
            </h3>
            <ul className="space-y-4 text-warm-800 text-lg" data-id="element-99">
              <li className="flex items-center gap-3" data-id="element-100">
                <span className="text-green-600" data-id="element-101">✓</span> Comer mejor sin usar
                aceite
              </li>
              <li className="flex items-center gap-3" data-id="element-102">
                <span className="text-green-600" data-id="element-103">✓</span> Cocinar más rápido
                todos los días
              </li>
              <li className="flex items-center gap-3" data-id="element-104">
                <span className="text-green-600" data-id="element-105">✓</span> Preparar comidas
                deliciosas en minutos
              </li>
              <li className="flex items-center gap-3" data-id="element-106">
                <span className="text-green-600" data-id="element-107">✓</span> Aprovechar realmente
                tu Air Fryer
              </li>
              <li className="flex items-center gap-3" data-id="element-108">
                <span className="text-green-600" data-id="element-109">✓</span> Dejar de perder tiempo
                buscando recetas que no funcionan
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-110">
          <button onClick={scrollToOffer} className="bg-primary hover:bg-primary-hover text-white font-bold text-xl md:text-2xl py-5 px-8 md:px-12 rounded-xl shadow-[0_0_30px_rgba(212,133,10,0.3)] hover:shadow-[0_0_40px_rgba(212,133,10,0.5)] transition-all duration-300 hover:scale-105 w-full md:w-auto" data-id="element-111">
            ¡SÍ! QUIERO COCINAR RECETAS INCREÍBLES
          </button>
        </div>
      </div>
    </section>;
}